import { Nullable } from "features/shared/types/nullable";

export const containsKey = <T extends object>(obj: T, key: string): boolean => {
  return Object.keys(obj).includes(key);
};

export const isEmpty = <T extends object>(obj: T) => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const isEmptyOrUndf = <T extends object>(obj: Nullable<T> | undefined) => {
  if (obj === undefined || obj === null) {
    return true;
  }

  return isEmpty(obj);
};

export const isPagedDataObj = <T extends object>(obj: T): boolean => {
  if (typeof obj === "object" && Object.keys(obj).length === 2) {
    return (
      (obj as any).hasOwnProperty("result") &&
      (obj as any).hasOwnProperty("count")
    );
  }

  return false;
};